import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Radio } from './Radio';
export const RadioGroup = ({ options, name, onChange, defaultValue, className = '', radioWrapperClass = '', label, required, value, outerClassName, }) => {
    const [selectedValue, setSelectedValue] = useState(defaultValue);
    const handleRadioChange = (event) => {
        const { value } = event.target;
        setSelectedValue(value);
        onChange && onChange(value);
    };
    return (_jsxs("div", { className: outerClassName, children: [label && (_jsxs("div", { className: "mb-2 text-gray-600", children: [label, required && _jsx("span", { className: "ml-0.5 inline-block text-gray-500", children: "*" })] })), _jsx("div", { className: className, children: options.map((option) => (_jsx(Radio, { inputProps: {
                        name: name,
                        value: option.value,
                        checked: (value || selectedValue) === option.value,
                        onChange: handleRadioChange,
                        disabled: option.disabled,
                    }, wrapperClass: radioWrapperClass, label: option.label }, option.value))) })] }));
};
//# sourceMappingURL=RadioGroup.js.map